module.exports = __webpack_public_path__ + "static/img/pic_spjx@2x.aeb90849.png";